<template>
    <div>
        <div>
            <el-form label-position="right" label-width="120px">
                <el-form-item label="序列号">
                    <el-input v-model="filter.serial_id" size="small"
                              placeholder="序列号" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="内部编号">
                    <el-input v-model="filter.sign" size="small"
                              placeholder="内部编号" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="来源">
                    <el-input v-model="filter.supplier" size="small"
                              placeholder="来源" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="所属">
                    <el-input v-model="filter.receiver" size="small"
                              placeholder="所属" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="仓库">
                    <el-select v-model="filter.store_id" placeholder="仓库"
                               clearable
                               filterable remote
                               style="width: 200px;"
                               :remote-method="handelSearchStore"
                               @change="handleChange">
                        <el-option
                                v-for="item in warehouses"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="filter.type" placeholder="类型"
                               style="width: 200px;"
                               clearable
                               disabled
                               filterable remote>
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品种类">
                    <el-select v-model="filter.category_id" placeholder="商品种类"
                               style="width: 200px;"
                               clearable
                               filterable remote>
                        <el-option
                                v-for="item in categorys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="filter.description" size="small"
                              placeholder="描述" style="width: 200px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_GetShopMsg",
        data() {
            return {
                filter:{
                    id:'',
                    serial_id:'',
                    sign:'',
                    supplier:'',
                    receiver:'',
                    store_id:'',
                    type:'',
                    category_id:''
                },
                warehouses:[],
                types:[
                    {
                        id:1,
                        name:'出售'
                    },
                    {
                        id:2,
                        name:'出租'
                    }],
                categorys:[
                    {
                        id:1,
                        name:'平板'
                    },
                    {
                        id:2,
                        name:'笔'
                    }
                ],

                button_loading:false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetShopName()
            this.handelSearchStore();
        },
        methods: {
            handleGetShopName(){
                this.button_loading=true;
                this.$axios.get(store.state.server + '/getShopById?shopId=' + this.$store.state.modal.data.shopId
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.filter=response.data.content.shop
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchStore(val=''){
                this.$axios.get(store.state.server + '/searchByStoreName?storeName=' +val+'&type=').then((response) => {
                    if (response.data.code == '0000') {
                        this.warehouses=response.data.content.storeName
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleChange(){
                for(let i=0;i<this.warehouses.length;i++){
                    if(this.warehouses[i].id==this.filter.storeId){
                        this.filter.type=this.warehouses[i].type
                        break;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>